import API, { baseURL } from './api';
import { SUCURSAL } from './auth';

// Ported from sge_infantil_web/src/services/dashboard.js (findDashboardData only —
// it's the single endpoint the original dashboard model actually calls; the other
// exports there were dead code, unused by the current dashboard screen).
export async function findDashboardData() {
  const resp = await API.get(
    `${baseURL}api/dashboard/${JSON.parse(localStorage.getItem(SUCURSAL)).id}`,
  );
  return resp;
}
